import { render, staticRenderFns } from "./EditInvoice.vue?vue&type=template&id=6b1b70c2"
import script from "./EditInvoice.vue?vue&type=script&lang=js"
export * from "./EditInvoice.vue?vue&type=script&lang=js"
import style0 from "./EditInvoice.vue?vue&type=style&index=0&id=6b1b70c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports